<template>
  <!-- 打印装箱单 -->
  <div style="page-break-after:always;">
    <div class="main" id="print" ref="print">
      <div class="top-pic">
        <img src="../../assets/dayindanicon/rakulogo.png" alt="" />
      </div>
      <!-- 顶部表格 -->
      <div class="top-table">
        <div class="title">注文{{ datas.porder_sn }}</div>
        <div class="row">
          <div><span>箱</span> <span>{{ datas.number }}</span></div>
          <div><span>業務担当</span> <span>{{ datas.porder.y_admin.realname }}</span></div>
        </div>
        <div class="row">
          <div><span>開封担当</span> <span>{{ datas.porder.p_admin.realname }}</span></div>
          <div><span>出荷担当</span> <span>{{ datas.porder.p_admin.realname }}</span></div>
        </div>
        <div class="row">
          <div><span>重量(KG)</span> <span>{{ datas.weight }}</span></div>
          <div><span>箱サイズ(CM)</span> <span>{{ datas.length }}*{{ datas.width }}*{{ datas.height }}</span></div>
        </div>
      </div>
      <!-- 底部表格 -->
      <div class="footer-table">
        <div class="table-header">
          <div class="flex05 item">番号</div>
          <div class="item">写真</div>
          <div class="flex2 item">注文NO</div>
          <div class="flex2 item">商品属性</div>
          <div class="item">数量</div>
          <div class="item">单价</div>
          <div class="item">検品担当</div>
          <div class="flex15 item">備考欄</div>
        </div>
        <div class="table-list">

          <!-- 行 -->
          <div class="row" v-for="(item, index) in datas.porder_freight_detail" :key="index">

            <div class="flex05 item">{{ item.order_detail.sorting }}</div>
            <div class="item">
              <img :src="item.order_detail.pic" alt="" />
            </div>
            <div class="flex2 item">
              {{ item.order_detail.order_sn }}
            </div>
            <div class="flex2 item">
              <div class="template">
                <div class="items" v-for="(items, indexs) in item.order_detail.detail" :key="indexs">
                  {{ items.key }}:{{ items.value }}
                </div>
              </div>
            </div>
            <div class="item">{{ item.num }}</div>
            <div class="item">{{ item.order_detail.confirm_price }}</div>
            <div class="item"></div>
            <div class="item flex15">{{ item.order_detail.client_remark }}</div>
          </div>
          <div class="row total">
            <div class="flex05 item"></div>
            <div class="item">合计：</div>
            <div class="flex2 item"></div>
            <div class="flex2 item"></div>

            <div class="item">{{ datas.total }}</div>
            <div class="item"></div>
            <div class="item"></div>
            <div class="flex15 item"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    datas: { type: Object }
  },
  created() {
    // this.$nextTick(() => {
    //   this.$print(this.$refs.print)
    // })
  },
  methods: {
    print() {
      this.$print(this.$refs.print)
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  width: 2480px;
  min-height: 3508px;
  background: #fff;
  padding: 60px;
  padding-top: 80px;
  box-sizing: border-box;
  color: #000000 !important;

  .top {
    border-top: 2px solid #000000;
  }

  div {
    box-sizing: border-box;
  }

  .top-pic {
    width: 280px;
    height: 280px;
    margin-bottom: 40px;

    img {

      width: 279px;
      height: 180px;
    }
  }

  .top-table {
    width: 2360px;
    height: 590px;
    border: 4px solid #000000;
    margin-bottom: 80px;

    .title {
      width: 100%;
      height: 200px;
      line-height: 200px;
      text-align: center;
      font-size: 40px;
      font-weight: 600;
      color: #000000;
      border-bottom: 2px solid #000000;
      margin-bottom: 0px;
    }

    .row {
      width: 100%;
      height: 142px;
      border-bottom: 2px solid #000000;
      display: flex;
      font-size: 40px;
      font-weight: 600;
      color: #000000;

      div {
        &:first-child {
          flex: 1;
          display: flex;

          span {
            display: flex;
            padding-left: 80px;
            height: 142px;

            &:first-child {
              width: 480px;
              height: 142px;
              line-height: 142px;
            }

            &:last-child {
              height: 142px;
              flex: 1;
              line-height: 142px;
              border-left: 2px solid #000000;
              border-right: 2px solid #000000;
            }
          }
        }

        &:last-child {
          flex: 1;
          display: flex;

          span {
            padding-left: 80px;

            &:first-child {
              width: 480px;
              height: 142px;
              line-height: 142px;
              border-right: 2px solid #000000;
            }

            &:last-child {
              flex: 1;
              height: 142px;
              line-height: 142px;
            }
          }
        }
      }


      &:last-child {
        border-bottom: 0px;
      }
    }
  }

  .footer-table {
    .table-header {
      width: 100%;

      border: 4px solid #000000;
      display: flex;

      font-size: 40px;

      font-weight: 600;
      color: #000000;
      border-bottom: 0;

      .item {
        padding: 30px 0;
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .flex05 {
        flex: 0.5
      }

      .flex15 {
        flex: 1.5
      }

      .flex2 {
        flex: 2
      }



    }

    .table-list {
      width: 100%;
      min-height: 160px;
      border: 4px solid #000000;
      border-bottom: 2px solid #000000;
      font-size: 40px;

      font-weight: 600;
      color: #000000;



      .row {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        min-height: 200px;
        border-bottom: 2px solid #000000;

        .item {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;

          img {

            height: 160px;
            height: 160px;
          }
        }

        .flex05 {
          flex: 0.5
        }

        .flex15 {
          flex: 1.5
        }

        .flex2 {
          flex: 2
        }


      }

      .total {
        width: 100%;
        min-height: 160px;

        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 2px solid #000000;
        text-align: center;

        div {
          border-right: 0 !important;
        }

      }
    }
  }
}
</style>
